import React, { Component } from 'react';
import Outbox from './Outbox.js';

export default class OutboxLembarRalat extends Component {
  render() {
    return (
      <Outbox type='TNDE_LEMBAR_RALAT'/>
    );
  }
}
